import { render, staticRenderFns } from "./AdminStats.vue?vue&type=template&id=5b5e8a8d&scoped=true"
import script from "./AdminStats.vue?vue&type=script&lang=js"
export * from "./AdminStats.vue?vue&type=script&lang=js"
import style0 from "./AdminStats.vue?vue&type=style&index=0&id=5b5e8a8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e8a8d",
  null
  
)

export default component.exports